import DateUtil from "../DateUtil";

export default {
    /**
     * 地区 limitCount = 0 不限制个数
     */
    formatterAreaNameListStr(item, limitCount = 0, noData = "无") {
        if (!item.extJsonObj) {
            return noData;
        }
        const areaList = item.extJsonObj.areaList;

        if (!areaList || areaList.length == 0) {
            return "通用地区";
        }
        const tempList = this.formatterAreaNameList(item, limitCount);
        const count = areaList.length;
        const isSliceList = count > limitCount && limitCount != 0;

        const resultStr = tempList.join("、");
        return isSliceList ? `${resultStr}...` : resultStr;
    },
    /**
     * 地区 limitCount = 0 不限制个数
     */
    formatterAreaNameListString(item, limitCount = 0, noData = "无") {
        if (!item.extJsonObj) {
            return noData;
        }
        const areaList = item.extJsonObj.areaList;

        if (!areaList || areaList.length == 0) {
            return noData;
        }
        const tempList = this.formatterAreaNameList(item, limitCount);
        const count = areaList.length;
        const isSliceList = count > limitCount && limitCount != 0;

        const resultStr = tempList.join("、");
        return isSliceList ? `${resultStr}...` : resultStr;
    },
    /**
     * 地区列表
     */
    formatterAreaNameList(item, limitCount = 0) {
        if (!item.extJsonObj) {
            return [];
        }
        const areaList = item.extJsonObj.areaList;

        if (!areaList || areaList.length == 0) {
            return [];
        }
        const count = areaList.length;
        let sourceList = [];
        const isSliceList = count > limitCount && limitCount != 0;
        if (isSliceList) {
            sourceList = areaList.slice(0, limitCount);
        } else {
            sourceList = areaList;
        }
        const templateList = [];
        sourceList.map((object) => {
            const str = this.formatterFullNameAddress(object);
            templateList.push(str);
        });
        return templateList;
    },
    /**
     * 单个全地址拼接
     */
    formatterFullNameAddress(item) {
        if (!item) return "-";

        if (item instanceof String) {
            return item;
        }
        let str = "";
        if (item.province && item.province.length > 0) {
            str = item.province;
        }
        if (item.city && item.city.length > 0) {
            str = `${str}-${item.city}`;
        }
        if (item.district && item.district.length > 0) {
            str = `${str}-${item.district}`;
        }
        return str;
    },
    /**
     * 格式字符串处理
     */
    formatterCellValueStr(col, row, value) {
        if (typeof value === "number" && (value == null || value == 0 || value == undefined)) {
            return 0;
        }
        if (typeof value === "number" && value) {
            return value;
        }
        if (value && value.toString().length > 0) {
            return value;
        } else {
            return "-";
        }
    },
    /**
     * 格式字符串处理
     */
    formatterDetailValueStr(value) {
        if (typeof value === "number" && value) {
            return value;
        }
        if (value && value.length > 0) {
            return value;
        } else {
            return "-";
        }
    },
    /**
     * 格式字符串处理
     */
    formatterNumberStr(value) {
        if (value == null || value == undefined || value.length <= 0) {
            return "-";
        }
        return value;
    },
};

/**
 * 根据学历代码获取对应的学历名称
 * @param {number} education - 学历代码（1:小学, 2:初中, 3:高中, 4:中专, 5-6:大学本科, 7:硕士研究生, 8:博士研究生, 9:未知）
 * @returns {string} 学历名称，未知代码返回 "-"
 */
export const formatterEducation = (education) => {
    switch (education) {
        case 1:
            return "小学";
        case 2:
            return "初中";
        case 3:
            return "高中";
        case 4:
            return "中专";
        case 5:
            return "大学专科";
        case 6:
            return "大学本科";
        case 7:
            return "硕士研究生";
        case 8:
            return "博士研究生";
        case 9:
            return "未知";
        default: {
            return "-";
        }
    }
};

/**
 * 车牌号处理
 * */
export const formatterDeviceAllNumberStr = (item, val = "-") => {
    const deviceNumber = item.deviceNumber;
    const deviceLaterNumber = item.deviceLaterNumber;

    if (item == null || (!deviceNumber && !deviceLaterNumber)) {
        return val;
    }
    let string = deviceNumber;
    if (deviceLaterNumber && deviceLaterNumber.length > 0) {
        if (string) {
            string = deviceNumber + "," + deviceLaterNumber;
        } else {
            string = deviceLaterNumber;
        }
    }
    return string;
};

/**
 * 行业显示- lzb 2026-03-17
 */
export const formatterIndustryNameListStr = (item, limitCount = 0, noData = "无") => {
    if (!item.extJsonObj) {
        return noData;
    }
    if (!item.extJsonObj.industryList || item.extJsonObj.industryList.length == 0) {
        return "通用行业";
    }

    const industryList = item.extJsonObj.industryList;
    const count = industryList.length;
    const isSliceList = count > limitCount && limitCount != 0;

    let sourceList = [];
    if (isSliceList) {
        sourceList = industryList.slice(0, limitCount);
    } else {
        sourceList = industryList;
    }
    const tempList = [];
    sourceList.map((object) => {
        const str = object.industryName;
        tempList.push(str);
    });
    const resultStr = tempList.join("、");

    return isSliceList ? `${resultStr}...` : resultStr;
};
/**
 * 处理培训类别 - lzb 2026-03-17
 */
export const formatterSubjectNameListStr = (item, limitCount = 0, noData = "无") => {
    if (!item.extJsonObj) {
        return noData;
    }
    if (!item.extJsonObj || !item.extJsonObj.subjectList || item.extJsonObj.subjectList.length == 0) {
        return "通用类别";
    }
    const subjectList = item.extJsonObj.subjectList;
    const count = subjectList.length;
    const isSliceList = count > limitCount && limitCount != 0;

    let sourceList = [];
    if (isSliceList) {
        sourceList = subjectList.slice(0, limitCount);
    } else {
        sourceList = subjectList;
    }

    const tempList = [];
    sourceList.map((object) => {
        const str = object.subjectName;
        tempList.push(str);
    });
    const resultStr = tempList.join("、");
    return isSliceList ? `${resultStr}...` : resultStr;
};

/**
 * 处理平台 - lzb 2026-03-17
 */
export const formatterPlatformListStr = (item, limitCount = 0, noData = "无") => {
    if (!item.extJsonObj) {
        return noData;
    }
    if (!item.extJsonObj || !item.extJsonObj.platCodeList || item.extJsonObj.platCodeList.length == 0) {
        return "通用类别";
    }
    const platCodeList = item.extJsonObj.platCodeList;
    const count = platCodeList.length;
    const isSliceList = count > limitCount && limitCount != 0;

    let sourceList = [];
    if (isSliceList) {
        sourceList = platCodeList.slice(0, limitCount);
    } else {
        sourceList = platCodeList;
    }

    const tempList = [];
    sourceList.map((object) => {
        const str = object.parameterName;
        tempList.push(str);
    });
    const resultStr = tempList.join("、");
    return isSliceList ? `${resultStr}...` : resultStr;
};
/**
 * 时间截取年-月-日
 */
export const formatterYMDDateStr = (dateTime) => {
    if (!dateTime || dateTime.length == 0) {
        return "-";
    }
    return DateUtil.formatterDateYMDStr(dateTime);
};
